<mat-form-field class="no-truncate">
  <div
    class="d-flex align-items-center"
    [class]="colorOptions?.allowColorPicker ? 'mr-n2 numericFieldWithColors' : 'numericField' "
  >
    <mat-icon svgIcon="sort-numeric"></mat-icon>
    <input
      #input
      matInput
      appNumericInput
      [ngModel]="context.data[context.column.columnDef]"
      (ngModelChange)="onChange($event)"
      [disabled]="!context.cell.allowEditing"
      [autofocus]="config?.autofocus"
      [options]="config?.options"
      [class]="config?.alignment ?? GridCellContentAlignment.Right"
      (blur)="onEndEdit()"
      inputmode="numeric"
      autocomplete="off"
    />

    <span class="percentageSymbol" *ngIf="config?.options?.allowPercentage">%</span>

    <app-color-picker-menu
      *ngIf="colorOptions?.allowColorPicker"
      [options]="colorOptions"
      [context]="context"
    ></app-color-picker-menu>
  </div>
</mat-form-field>
